import script from "./CompanyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyModal.vue?vue&type=script&setup=true&lang=js"

import "./CompanyModal.vue?vue&type=style&index=0&id=c2398fac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2398fac"]])

export default __exports__